import React, {useState} from 'react'
import {TipTapEditor} from './tiptap/TipTapEditor'

interface HTMLEditorProps {
  value: string
  onChange: (value: string) => void
  height?: number
  variables?: string[]
}

export const HTMLEditor: React.FC<HTMLEditorProps> = ({value, onChange, height = 400, variables = []}) => {
  const [showCode, setShowCode] = useState(false)

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center mb-2'>
        <label className='form-label mb-0'>Contenido HTML</label>
        <button
          type='button'
          className='btn btn-sm btn-outline-secondary'
          onClick={() => setShowCode(!showCode)}
        >
          <i className={`bi ${showCode ? 'bi-eye' : 'bi-code-slash'} me-1`}></i>
          {showCode ? 'Visual Editor' : 'View Code'}
        </button>
      </div>

      {showCode ? (
        <>
          <textarea
            className='form-control font-monospace'
            style={{minHeight: `${height}px`, fontSize: '13px'}}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          <div className='form-text mt-2'>
            <i className='bi bi-info-circle me-1'></i>
            Editing raw HTML. Switch to Visual Editor for WYSIWYG editing.
          </div>
        </>
      ) : (
        <>
          <TipTapEditor value={value} onChange={onChange} height={height} variables={variables} />
          <div className='form-text mt-2'>
            <i className='bi bi-info-circle me-1'></i>
            Use the toolbar above for rich formatting. Switch to "View Code" to see/edit raw HTML.
            <br />
            Variables: Use <code>{'{{variableName}}'}</code> format.
          </div>
        </>
      )}
    </div>
  )
}
